module.exports = __webpack_public_path__ + "img/list.1d39a467.png";